
export const formatCurrency = (value: number, symbol: string): string => {
  const parts = value.toFixed(2).split('.')
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  return `${integerPart},${parts[1]}&nbsp;${symbol}`
}

export const formattValue = (
  value: number, // value in cents
  currency: string = 'PLN',
  locale: string = 'pl-PL'
): string => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2
  })

  // Return formatted value with normal spaces replaced with non-breaking spaces
  return formatter.format(value / 100).replace(/\s/g, '\u00A0')
}

export const convertCentsToAmount = (cents: number): number =>
  Number((cents / 100).toFixed(2))
export const convertAmountToCents = (amount: number): number =>
  Number((amount * 100).toFixed(2))

export const removeEmptySpacesFromCurrency = (currency: string): string => {
  return currency.replaceAll('&nbsp;', '').replace(',00', '')
}
